import React from 'react';
import { motion } from 'framer-motion';
import { FloatingElements } from './FloatingElements';
import { PiggyBank } from './PiggyBank';
import { JarVisual } from './JarVisual';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col justify-center items-center px-5 py-20 bg-dark overflow-hidden" data-id="element-28">
      <div className="absolute inset-0 bg-radial-money" aria-hidden="true" data-id="element-29" />
      <div className="hidden md:block" data-id="element-30">
        <FloatingElements count={6} variant="money" data-id="element-31" />
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-32">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.35,
        delay: 0.05
      }} data-id="element-33">
          <span className="inline-block text-[10px] sm:text-xs font-display font-bold tracking-[0.2em] uppercase text-money border border-money/30 rounded-full px-5 py-2 mb-8" data-id="element-34">
            💰 Sistema Familiar de Educación Financiera
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 className="font-display font-extrabold leading-[0.95] mb-8" initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.1
      }} data-id="element-35">
          <span className="block text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white mb-2" data-id="element-36">
            Tu hijo no es malcriado.
          </span>
          <span className="block text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-gradient-money" data-id="element-37">
            Tu casa no tiene sistema.
          </span>
        </motion.h1>

        {/* Opening lead */}
        <motion.div className="max-w-xl mx-auto mb-10" initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.2
      }} data-id="element-38">
          <p className="font-serif italic text-lg md:text-xl text-white/50 leading-relaxed mb-4" data-id="element-39">
            «¿Me lo compras?» — y empieza la negociación, la culpa, el
            cansancio.
          </p>
          <p className="font-sans text-lg md:text-xl text-white/80 leading-relaxed" data-id="element-40">
            No es falta de amor. Es que tu casa no tiene un{' '}
            <span className="text-money font-semibold" data-id="element-41">
              sistema para el dinero
            </span>
            . Solo reacciones.
          </p>
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.35,
        delay: 0.3
      }} data-id="element-42">
          <a href="#precio" className="inline-block bg-gradient-to-r from-money-dark via-money to-emerald-400 text-white font-display font-extrabold text-lg md:text-xl px-10 py-5 rounded-2xl cta-pulse hover:scale-[1.03] active:scale-[0.98] transition-transform duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-money focus-visible:ring-offset-2 focus-visible:ring-offset-dark" data-id="element-43">
            QUIERO EL SISTEMA →
          </a>
        </motion.div>

        {/* Piggy Bank */}
        <motion.div className="mt-12 mb-8" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.35
      }} data-id="element-44">
          <PiggyBank size="lg" data-id="element-45" />
        </motion.div>

        {/* Jar icons */}
        <motion.div className="flex justify-center items-end gap-8" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.45
      }} data-id="element-46">
          <div className="flex flex-col items-center gap-1.5" data-id="element-47">
            <JarVisual color="spend" label="Gastar" fillPercent={60} size="sm" data-id="element-48" />
            <span className="text-[10px] font-display font-bold uppercase tracking-wider text-spend" data-id="element-49">
              Gastar
            </span>
          </div>
          <div className="flex flex-col items-center gap-1.5" data-id="element-50">
            <JarVisual color="save" label="Ahorrar" fillPercent={75} size="sm" data-id="element-51" />
            <span className="text-[10px] font-display font-bold uppercase tracking-wider text-save" data-id="element-52">
              Ahorrar
            </span>
          </div>
          <div className="flex flex-col items-center gap-1.5" data-id="element-53">
            <JarVisual color="give" label="Dar" fillPercent={45} size="sm" data-id="element-54" />
            <span className="text-[10px] font-display font-bold uppercase tracking-wider text-give" data-id="element-55">
              Dar
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}